/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-05 22:50:41
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-06 23:21:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/Components/index.ts
 */
export { default as SecondaryOptions } from './SecondaryOptions';
export { default as ServiceDetail } from './ServiceDetail';
